import React, { useLayoutEffect, useRef } from 'react'
import './sliderpre.css'
import ImageSlider from '../../../FinalOutput/Components/Slider-prewedding/ImageSlider'
import PreWeddingVideo from '../../../FinalOutput/Components/Slider-prewedding/PreWeddingVideo';

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)


const Sliderpre = ({details}) => {

  const sectionRef = useRef(null)

const leftFlowerRef = useRef(null)
const rightFlowerRef = useRef(null)
const bottomFlowerRef = useRef(null)



     const images = details?.footerImages || [];
      const preWeddingLink = details?.preWeddingLink?.trim();

        const hasImages = images.length > 0;
  const hasPreWedding = !!preWeddingLink;

  useLayoutEffect(() => {
  const ctx = gsap.context(() => {

    if (!sectionRef.current) return

    const elements = [
      leftFlowerRef.current,
      rightFlowerRef.current,
      bottomFlowerRef.current,
    ].filter(Boolean)

    if (!elements.length) return

    gsap.from(elements, {
      autoAlpha: 0,
      duration: 1,
      stagger: 0.12,
      ease: "power2.out",

      scrollTrigger: {
        trigger: sectionRef.current,
        start: "top 75%",
        once: true,
      },
    })

  }, sectionRef)

  return () => ctx.revert()
}, [])


    if (!hasImages && !hasPreWedding) {
    return null;
  }



  return (
     <section
     ref={sectionRef}
      className={`t1-slider-section
       ${details?.theme || ''}
       ${  hasPreWedding ? "has-prewedding" : ""}`
        
        }
    >
     
     <img
     ref={leftFlowerRef}
        src="/slider-corner.png"
        alt="slider-elem-left"
        className="t1-slider-left-corner"
      />

       <img
        ref={rightFlowerRef}
        src="/slider-right-corner.png"
        alt="slider-elem-right"
        className="t1-slider-right-corner"
      />
      

{hasImages &&  <ImageSlider  images={images}  /> }
      
{preWeddingLink &&  <PreWeddingVideo   link={preWeddingLink}  /> }
       
        <img
         ref={bottomFlowerRef}
        src="/slider-right-corner.png"
        alt="slider-elem-right"
        className="t1-slider-right-bottom-corner"
      />


      

      </section>
  )
}

export default Sliderpre